/* eslint-disable react-hooks/exhaustive-deps */
import { Suspense, lazy } from 'react';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import PublicReceipt from '../pages/PublicReceipt';

const Loginv2 = lazy(() => import('../pages/Login/Login'));
const SignUpV2 = lazy(() => import('../pages/SignUp/SignUp'));
const ForgotPasswordv2 = lazy(() => import('../pages/ForgotPassword/ForgotPassword'));
const RessetPasswordv2 = lazy(() => import('../pages/ResetPassword/ResetPassword'));
const CustomersRessetPassword = lazy(
  () => import('../pages/ResetPassword/CustomersRessetPassword')
);
const AccountEmailVerificationv2 = lazy(
  () => import('../pages/AccountEmailVerification/AccountEmailVerification')
);
const TermsAndConditionsv2 = lazy(() => import('../pages/TermsAndConditions/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy/PrivacyPolicy'));
const CFDITermsAndConditionsv2 = lazy(
  () => import('../pages/CFDITermsAndConditions/CFDITermsAndConditions')
);
const Reviewsv2 = lazy(() => import('../pages/CustomerReview/CustomerReview'));

const Landing = () => (
  <Router>
    <Suspense>
      <Switch>
        <Route path="/" component={Loginv2} exact />
        <Route path="/login" component={Loginv2} exact />
        <Route path="/sign-up" component={SignUpV2} exact />
        <Route path="/forget-password" component={ForgotPasswordv2} exact />
        <Route path="/reset-password" component={RessetPasswordv2} exact />
        <Route path="/customers-reset-password" component={CustomersRessetPassword} exact />
        <Route path="/validate-email" component={AccountEmailVerificationv2} exact />
        <Route path="/terms" component={TermsAndConditionsv2} exact />
        <Route path="/privacy" component={PrivacyPolicy} exact />
        <Route path="/CFDITermsAndConditions" component={CFDITermsAndConditionsv2} exact />
        <Route path="/reviews/:storeId/:customerId?" component={Reviewsv2} exact />
        <Route path="/receipt/:publicToken" component={PublicReceipt} exact />
        <Redirect exact from="*" to="/" />
      </Switch>
    </Suspense>
  </Router>
);

export default Landing;
